import React from "react";
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import VistaPdf from '../documentViewer/VistaPdf'
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import { Link } from "react-router-dom";
import { getRecibos } from "./ReportesService"
import { idEmpresa, URL } from "../../constans/constants"
import { Button, Container, Row, Col, Modal, Form } from "react-bootstrap";
import arrowBack from '../../styles/icons/arrow_back.svg';
import pdfIcon from '../../styles/icons/pdf.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class ReporteRecibos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Ingrese Pin de Firma",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedRecibo: {
        recibo: "",
        idLote: "",
        numeroLote: "",
        tipoDocumento: "",
        fechaCarga: "",
        empleado: "",
        estado: "",
        estadoMTESS: false
      },
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogPinOpen: false,
      open: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      severityFlash: "",
      pageSize: 10,
      loading:true,
      search:""
    };
    let pantallaAnterior = null;
    this.setPantallaAnterior();
    this.tableRef = React.createRef();

  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.tableRef.current && this.tableRef.current.onQueryChange();
    }
  }

  setPantallaAnterior = () => {
    localStorage.setItem("urlAnterior", window.location.href);
    this.pantallaAnterior = (localStorage.getItem("urlRaiz")).substring(localStorage.getItem("urlRaiz").indexOf("#"));
}

  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
    });
  };
  descargarRecibos = () => {
    if (this.props.match.params.estado) {
      window.location.href = URL + "reportes/recibos/descargar?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa() + "&estado=" + this.props.match.params.estado;
    } else {
      window.location.href = URL + "reportes/recibos/descargar?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa();
    }

  }
  descargarRecibosXls = () => {
    if (this.props.match.params.estado) {
      window.location.href = URL + "reportes/recibos/descargar/xls?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa() + "&estado=" + this.props.match.params.estado;
    } else {
      window.location.href = URL + "reportes/recibos/descargar/xls?usuario=" + this.props.match.params.id + "&idEmpresa=" + idEmpresa();
    }

  }

  handleDialogPin = (value, mensaje = "", severity = "") => {
    this.setState({
      dialogPinOpen: value,
      mostrarMensajeFlash: true,
      mensajeFlash: mensaje,
      severityFlash: severity
    });
  };
  handleClose = (value) => {
    this.setState({
      open: value
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };
  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchRecibos(0, this.state.pageSize, "");
  }
  
  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchRecibos(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }



  fetchRecibos(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getRecibos(page, pageSize, search, this.props.match.params.id, this.props.match.params.estado).then(() => {
      this.setState({
        recibos: this.props.reporteReciboData.reporteRecibo,
        page: this.props.reporteReciboData.page,
        totalCount: this.props.reporteReciboData.totalCount,
        totalPages: Math.ceil(this.props.reporteReciboData.totalCount / pageSize),
        loading: false 
      });
    });
  }
  
  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchRecibos(0, this.state.pageSize, this.state.search);
    });
  };

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <Modal
              fullWidth={true}
              maxWidth="md"
              maxHeight="600px"
              show={this.state.dialogIsOpen}
              onHide={this.handleDialog}>
              <VistaPdf
                idLote={this.state.selectedRecibo.idLote}
                recibo={this.state.selectedRecibo}
                handleClose={this.handleDialogVerDatos}
                type={this.state.dialogType}
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
              />
            </Modal>
            <div className="sectionHeader" style={{ marginBottom: '20px' }}>
              <div className="actionTitle" >
                <a type='button' style={{ paddingTop: '7px' }}>
                  <img src={arrowBack} onClick={() => window.location.href = this.pantallaAnterior} />
                </a>
                <h1 className="pageTitle"> {"Recibos de " + this.props.match.params.colaborador} </h1>
              </div>

              <div className="actions">
                <a className="btn btn-primary" onClick={this.descargarRecibos}> Descargar  ZIP</a>
               <a className="btn btn-primary" style={{background:"#00b74a"}} onClick={this.descargarRecibosXls}> Descargar  XLS</a> 
              </div>
            </div>
            <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            <div className="contentPage card" style={{ padding: "0px" }}>
            {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
                <div>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Recibo</th>
                      <th scope="col">Lote</th>
                      <th scope="col">Concepto</th>
                      <th scope="col">fecha</th>
                      <th scope="col">Tipo de Documento</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.reporteReciboData.reporteRecibo.map((recibo, index) => (
                      <tr key={index}>
                        <th scope="row">{recibo.recibo}</th>
                        <td>{recibo.numeroLote}</td>
                        <td>{recibo.descripcionLote}</td>
                        <td>{recibo.fechaCarga}</td>
                        <td>{recibo.tipoDocumento}</td>
                        <td>{recibo.estado}</td>
                        <td>
                          <div className="table-actions">
                          <Link to={{
                        pathname: '/reporte/nro-recibo/'+recibo.recibo+'/nro-lote/'+ recibo.idLote+'/ver', 
                      }}>
                          <a class="btn btn-secondary btn-md btn-floating">
                          <img src={pdfIcon} />
                          </a>
                        </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                <label>
                  Mostrar
                  <select
                    className="form-control custom-select"
                    id="maxRows"
                    name="state"
                    value={this.state.pageSize}
                    onChange={this.handlePageSizeChange}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </select>
                  resultados.
                </label>

                <ul className="pagination mb-0">
                  <li
                    className={`page-item ${
                      this.state.page === 0 ? "disabled" : ""
                    }`}
                    onClick={() => this.handlePageChange(this.state.page - 1)}
                  >
                    <a className="page-link">
                      <span className="material-icons">chevron_left</span>
                    </a>
                  </li>
                  {this.renderPageNumbers()}
                  <li
                    className={`page-item ${
                      this.state.page === this.state.totalPages - 1
                        ? "disabled"
                        : ""
                    }`}
                    onClick={() => this.handlePageChange(this.state.page + 1)}
                  >
                    <a className="page-link">
                      <span className="material-icons">chevron_right</span>
                    </a>
                  </li>
                </ul>
              </div>
              </div>)}
            </div>
            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={this.state.severityFlash}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getRecibos: (page, size, search, usuario, estado) => dispatch(getRecibos(page, size, search, usuario, estado)),
});

const mapStateToProps = (state) => ({
  reporteReciboData: state.reporteReciboData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReporteRecibos);
